// Файл DocxViewer.js

/**
 * Компонент подготавливает DOCX и отображает его в браузере через общий нормализатор предварительного просмотра.
 */

import { useEffect, useRef, useState } from 'react';
import { renderAsync } from 'docx-preview';

import { normalize_docx_for_preview } from './docx_preview_normalizer';



const DocxViewer = ({ blob }) => {
    const containerRef = useRef(null);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!blob || !containerRef.current) {
            return undefined;
        }

        let cancelled = false;
        const container = containerRef.current;
        container.innerHTML = '';
        setError('');

        const render_document = async () => {
            try {
                const normalized_blob = await normalize_docx_for_preview(blob);

                if (cancelled) {
                    return;
                }

                await renderAsync(normalized_blob, container, undefined, {
                    className: 'docx-preview',
                    inWrapper: true,
                    breakPages: true,
                    ignoreWidth: false,
                    ignoreHeight: false,
                    ignoreFonts: false,
                    useBase64URL: true,
                    renderHeaders: true,
                    renderFooters: true,
                    renderFootnotes: true,
                });

            } catch (render_error) {
                if (!cancelled) {
                    setError('Не удалось отобразить документ');
                }
            }
        };

        render_document();

        return () => {
            cancelled = true;
        };
    }, [blob]);

    if (error) {
        return (
            <div className="file-viewer__message flex-column flex-align-center file-viewer__message--error">
                {error}
            </div>
        );
    }

    return <div className="docx-viewer" ref={containerRef} />;
};


export default DocxViewer;
